import styled from 'styled-components';

const Container = styled.div`
  text-align: center;
  svg {
    width: 120px;
    height: 120px;
  }
`;

const SuccessIconComponent = { Container };
export default SuccessIconComponent;
